import { render, staticRenderFns } from "./complainant_project_info.vue?vue&type=template&id=4f0539ec&scoped=true"
import script from "./complainant_project_info.vue?vue&type=script&lang=js"
export * from "./complainant_project_info.vue?vue&type=script&lang=js"
import style0 from "./complainant_project_info.vue?vue&type=style&index=0&id=4f0539ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0539ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f0539ec')) {
      api.createRecord('4f0539ec', component.options)
    } else {
      api.reload('4f0539ec', component.options)
    }
    module.hot.accept("./complainant_project_info.vue?vue&type=template&id=4f0539ec&scoped=true", function () {
      api.rerender('4f0539ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/complaintreporting/online/components/complainant_project_info.vue"
export default component.exports